import { Api } from '../../Api';
import {
    ISettingsNetSettlementsAmountsDto,
    ISettingsNetSettlementsBrokerLevelsDto,
    ISettingsNetSettlementsPositionsDto,
} from './interfaces';
import { ISettingsBrokerLevelsGetParams, ISettingsNetSettlementsGetParams } from './params';

export class NetSettlements {
    private static _basePath = '/NetSettlement';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${NetSettlements._basePath}`;
        return {
            async getAmounts({ startDate, endDate }: ISettingsNetSettlementsGetParams) {
                const path = '/amounts';
                return await Api.get<ISettingsNetSettlementsAmountsDto[]>({
                    path: `${basePath}${path}/?startDate=${startDate}&endDate=${endDate}`,
                });
            },
            async getPositions({ startDate, endDate }: ISettingsNetSettlementsGetParams) {
                const path = '/positions';
                return await Api.get<ISettingsNetSettlementsPositionsDto[]>({
                    path: `${basePath}${path}/?startDate=${startDate}&endDate=${endDate}`,
                });
            },
            async getBrokerLevels({ date }: ISettingsBrokerLevelsGetParams) {
                const path = '/broker';
                return await Api.get<ISettingsNetSettlementsBrokerLevelsDto[]>({
                    path: `${basePath}${path}/?date=${date}`,
                });
            },
        };
    }
}
